import { __extends } from "tslib";
import { deserializeAws_restJson1_1ListTemplatesCommand, serializeAws_restJson1_1ListTemplatesCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListTemplatesCommand = /** @class */ (function (_super) {
    __extends(ListTemplatesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListTemplatesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListTemplatesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListTemplatesCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1ListTemplatesCommand(input, context);
    };
    ListTemplatesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1ListTemplatesCommand(output, context);
    };
    return ListTemplatesCommand;
}($Command));
export { ListTemplatesCommand };
//# sourceMappingURL=ListTemplatesCommand.js.map